export default __webpack_public_path__ + "static/media/5.871e6ee4.svg";